/**
 * Wave 1b (Jules): above-fold Junip summary shows only when stars + count
 * both render. Never leave a bare "(N)" hole; collapse when hidden.
 *
 * Important: only target the summary ROOT (.junip-product-summary), never
 * descendants like .junip-product-summary-review-count (attribute *= matches
 * those and would hide the count, then fail hasCount).
 */
(function () {
  var HIDE = 'tsf-junip-summary--hide';
  var filterId = 0;

  function localFilterContainer(toggle) {
    var parent = toggle && toggle.parentElement;
    if (!parent) return null;
    var containers = Array.from(parent.children).filter(function (child) {
      return child.matches && child.matches('.junip-filters-container');
    });
    if (containers.length === 1) return containers[0];

    var requested = toggle.getAttribute('aria-controls');
    var requestedContainer = containers.find(function (container) { return container.id === requested; });
    if (requestedContainer) return requestedContainer;

    var sibling = toggle.nextElementSibling;
    while (sibling) {
      if (sibling.matches && sibling.matches('.junip-filters-container')) return sibling;
      sibling = sibling.nextElementSibling;
    }
    return null;
  }

  function uniqueFilterId(container) {
    var current = container.id;
    if (current) {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        var matches = document.querySelectorAll('#' + window.CSS.escape(current));
        if (matches.length === 1 && matches[0] === container) return current;
      } else {
        var duplicateFilter = Array.from(document.querySelectorAll('.junip-filters-container[id]')).some(function (node) {
          return node !== container && node.id === current;
        });
        if (document.getElementById(current) === container && !duplicateFilter) return current;
      }
    }

    var candidate;
    do {
      filterId += 1;
      candidate = 'junip-filters-container-tsf-' + filterId;
    } while (document.getElementById(candidate));
    container.id = candidate;
    return candidate;
  }

  function repairFilterControl(toggle) {
    if (!toggle || !toggle.matches || !toggle.matches('.junip-filters-toggle[aria-controls]')) return;
    var container = localFilterContainer(toggle);
    if (!container) return;
    var id = uniqueFilterId(container);
    if (toggle.getAttribute('aria-controls') !== id) toggle.setAttribute('aria-controls', id);
  }

  function starNodes(root) {
    return root.querySelectorAll('.junip-product-summary-star');
  }

  function hasCount(root) {
    if (root.querySelector('.junip-product-summary-review-count')) return true;
    // Compact Junip (homepage hero) often puts the count only in aria-label,
    // e.g. role=img aria-label="4.51 stars, 183 reviews" — not in visible text.
    var labeled = root.querySelector('[aria-label]');
    if (labeled) {
      var al = (labeled.getAttribute('aria-label') || '').replace(/\s+/g, ' ');
      if (/\d+\s*reviews?/i.test(al) || /\d+(?:\.\d+)?\s*stars?/i.test(al)) return true;
    }
    // textContent avoids the synchronous layout flush that innerText requires.
    var text = (root.textContent || '').replace(/\s+/g, ' ');
    return /\(\s*\d+\s*\)/.test(text) || /\d+\s*reviews?/i.test(text);
  }

  function starsPainted(root) {
    // The reviews section of thinslim-site.css paints every Junip summary star with a CSS star and
    // restores inline-path SVGs with :has(). Once Junip supplies a star node,
    // one of those two paths is guaranteed without forcing computed style and
    // layout for every summary on every app mutation.
    return starNodes(root).length > 0;
  }

  function blockHost(root) {
    return (
      root.closest('[id^="shopify-block-"]') ||
      root.closest('.shopify-block') ||
      root.closest('.shopify-app-block') ||
      null
    );
  }

  function setHidden(el, hide) {
    if (!el) return;
    el.classList.toggle(HIDE, !!hide);
  }

  function evaluate(root) {
    if (!root || !root.classList || !root.classList.contains('junip-product-summary')) return;
    // Skip descendant false-positives
    if (root.className.indexOf('junip-product-summary-') !== -1 && !/(^| )junip-product-summary( |$)/.test(root.className)) {
      return;
    }

    var inCard = !!root.closest('.tsf-product-card, .rebuy-product-block');
    var painted = starsPainted(root);
    var count = hasCount(root);
    var ok = painted && count;
    if (!starNodes(root).length && !(root.textContent || '').trim() && !root.querySelector('.junip-product-summary-review-count')) {
      ok = false;
    }
    if (count && !painted) ok = false;

    setHidden(root, !ok);
    if (!inCard) setHidden(blockHost(root), !ok);
  }

  function scan(selector) {
    document.querySelectorAll(selector || '#MainContent .junip-product-summary').forEach(function (el) {
      // Root token only. Previous \\s typo never rematched once Junip added
      // extra classes (e.g. junip-product-summary-rendered), leaving --hide stuck.
      if (!/(?:^|\s)junip-product-summary(?:\s|$)/.test(el.className)) return;
      evaluate(el);
    });
  }

  function scanFilterControls(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (root && root.matches && root.matches('.junip-filters-toggle[aria-controls]')) repairFilterControl(root);
    scope.querySelectorAll('.junip-filters-toggle[aria-controls]').forEach(repairFilterControl);
  }

  var pending = new Set();
  var pendingFilterControls = new Set();
  var frame = 0;
  function schedulePending() {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      var roots = Array.from(pending);
      var filterControls = Array.from(pendingFilterControls);
      pending.clear();
      pendingFilterControls.clear();
      roots.forEach(evaluate);
      filterControls.forEach(repairFilterControl);
    });
  }

  function enqueue(root) {
    if (!root || !root.matches || !root.matches('.junip-product-summary')) return;
    pending.add(root);
    schedulePending();
  }

  function enqueueFilterControl(toggle) {
    if (!toggle || !toggle.matches || !toggle.matches('.junip-filters-toggle[aria-controls]')) return;
    pendingFilterControls.add(toggle);
    schedulePending();
  }

  function collect(node) {
    if (!node) return;
    var element = node.nodeType === 1 ? node : node.parentElement;
    if (!element) return;
    enqueue(element.matches('.junip-product-summary') ? element : element.closest('.junip-product-summary'));
    if (element.querySelectorAll) element.querySelectorAll('.junip-product-summary').forEach(enqueue);
    enqueueFilterControl(element.matches('.junip-filters-toggle[aria-controls]') ? element : null);
    if (element.matches('.junip-filters-container')) {
      Array.from(element.parentElement ? element.parentElement.children : []).forEach(enqueueFilterControl);
    }
    if (element.querySelectorAll) element.querySelectorAll('.junip-filters-toggle[aria-controls]').forEach(enqueueFilterControl);
  }

  function boot() {
    scan();
    scanFilterControls(document.querySelector('#MainContent'));
    var main = document.querySelector('#MainContent');
    if (main) {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          collect(record.target);
          record.addedNodes.forEach(collect);
        });
      }).observe(main, {
        attributes: true,
        attributeFilter: ['aria-controls', 'id'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    [150, 500, 1200, 2500, 5000, 9000].forEach(function (ms) {
      // Keep the established Junip retry points, but revisit only unresolved
      // summaries. Visible summaries are updated by their own mutations.
      setTimeout(function () { scan('#MainContent .junip-product-summary.' + HIDE); }, ms);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
